/**
 * Stripe Personal Plan Config
 *
 * Backward-compatible adapter that exposes personal Stripe plan constants
 * from the centralized Losi monetization config.
 *
 * Primary responsibilities:
 * - Export active personal plan ids and lookup keys
 * - Preserve legacy lookup-key constants for safe fallback handling
 * - Keep existing import sites compiling during migration
 *
 * Dependencies:
 * - `lib/billing/losi-pricing.ts`
 */

import {
  ACTIVE_PERSONAL_STRIPE_LOOKUP_KEYS,
  LEGACY_PERSONAL_STRIPE_LOOKUP_KEYS,
  getPersonalPlanLookupKey
} from '@/lib/billing/losi-pricing'

export const STRIPE_TRIAL_PERIOD_DAYS = process.env.NEXT_PUBLIC_STRIPE_TRIAL_DAYS
  ? parseInt(process.env.NEXT_PUBLIC_STRIPE_TRIAL_DAYS)
  : 3

export const PLAN_FREE = 'free'
export const PLAN_PLUS = 'plus'
export const PLAN_PRO = 'pro'
export const PLAN_ULTRA = 'ultra'

// Legacy-only identifiers retained for compatibility while old subscriptions
// are normalized through the shared billing helpers.
export const PLAN_PREMIUM = 'premium'
export const PLAN_STUDIO = 'studio'
export const PLAN_BYOK = 'byok'

export const PLAN_PLUS_MONTHLY = getPersonalPlanLookupKey('plus', 'monthly')!
export const PLAN_PLUS_YEARLY = getPersonalPlanLookupKey('plus', 'yearly')!
export const PLAN_PRO_MONTHLY = getPersonalPlanLookupKey('pro', 'monthly')!
export const PLAN_PRO_YEARLY = getPersonalPlanLookupKey('pro', 'yearly')!
export const PLAN_ULTRA_MONTHLY = getPersonalPlanLookupKey('ultra', 'monthly')!
export const PLAN_ULTRA_YEARLY = getPersonalPlanLookupKey('ultra', 'yearly')!

export const PLAN_PREMIUM_MONTHLY = 'premium_monthly'
export const PLAN_PREMIUM_YEARLY = 'premium_yearly'
export const PLAN_BYOK_MONTHLY = 'byok_monthly'
export const PLAN_BYOK_YEARLY = 'byok_yearly'
export const PLAN_STUDIO_SUBSCRIPTION = 'studio_subscription'

export const PLANS = [...ACTIVE_PERSONAL_STRIPE_LOOKUP_KEYS]

export const LEGACY_PLANS = [...LEGACY_PERSONAL_STRIPE_LOOKUP_KEYS]

export const ACTIVE_PLAN_STATUSES = ['active', 'trialing']
